import { configureStore } from '@reduxjs/toolkit';
import parentReducer from './slices/parentSlice';
import userReducer from './slices/userSlice';

export const store = configureStore({
    reducer: {
        parent: parentReducer,
        user: userReducer
    }
});